import React, { useState, useContext, useEffect } from "react";
import Select from "react-select";
import "./EmployeeDiscipline.css";
import { UserContext } from "../../../../contexts/CurrentUserContext";
import {
  getAllGroups,
  getUsersSummary,
  getGroupAttendanceMonth,
  getGroupAttendance6Month,
  getGroupAttendanceYear,
  getEmployeeAttendanceMonth,
  getEmployeeAttendance6Month,
  getEmployeeAttendanceYear,
  getAPIURL,
} from "../../../../api/api";
// Кастомные стили для селектов без зеленых цветов
const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    border: "1px solid #E0E0E0",
    padding: "5px",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 300,
    lineHeight: "19.12px",
    minHeight: "42px",
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "white",
    "&:hover": {
      borderColor: "#E0E0E0",
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    borderRadius: "10px",
    marginTop: "5px",
    width: "100%",
    zIndex: 2,
    backgroundColor: "white",
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 300,
    backgroundColor: state.isSelected ? "#f5f5f5" : "white",
    color: state.isSelected ? "#333" : "#333",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#999",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 300,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 300,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "2px 8px",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#666",
  }),
};

const EmployeeDiscipline = () => {
  const { userData } = useContext(UserContext);
  const [selectedPeriod, setSelectedPeriod] = useState("month");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [disciplineData, setDisciplineData] = useState(null);
  const [disciplineLoading, setDisciplineLoading] = useState(false);
  const [disciplineError, setDisciplineError] = useState(null);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [employeeDetailsLoading, setEmployeeDetailsLoading] = useState(false);
  const [employeeDetailsError, setEmployeeDetailsError] = useState(null);
  const [departmentEmployees, setDepartmentEmployees] = useState([]);

  // Функция для загрузки данных дисциплины
  const loadDisciplineData = async (groupId, period, date) => {
    console.log("loadDisciplineData вызвана с параметрами:", {
      groupId,
      period,
      date,
    });

    if (!groupId || groupId === "all" || groupId === undefined) {
      console.log(
        "Группа не выбрана или выбрана 'all' или undefined, очищаем данные"
      );
      setDisciplineData(null);
      return;
    }

    try {
      console.log("Начинаем загрузку данных дисциплины...");
      setDisciplineLoading(true);
      setDisciplineError(null);

      let data;
      const year = date.getFullYear();
      const month = date.getMonth() + 1;

      console.log("Параметры запроса:", { year, month, period });

      if (period === "month") {
        console.log("Загружаем данные за месяц");
        data = await getGroupAttendanceMonth(groupId, year, month);
      } else if (period === "6months") {
        console.log("Загружаем данные за 6 месяцев");
        const startDate = new Date(date);
        const endDate = new Date(date);
        endDate.setMonth(endDate.getMonth() + 5);

        data = await getGroupAttendance6Month(
          groupId,
          startDate.getFullYear(),
          startDate.getMonth() + 1,
          endDate.getFullYear(),
          endDate.getMonth() + 1
        );
      } else if (period === "year") {
        console.log("Загружаем данные за год");
        data = await getGroupAttendanceYear(groupId, year);
      }

      console.log("Данные загружены:", data);
      setDisciplineData(data);
    } catch (error) {
      console.error("Ошибка при загрузке данных дисциплины:", error);
      setDisciplineError(error.message);
    } finally {
      setDisciplineLoading(false);
    }
  };

  // Загрузка данных при монтировании компонента
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        // Загружаем отделы
        const departmentsData = await getAllGroups();
        console.log("departmentsData:", departmentsData);
        console.log("departmentsData type:", typeof departmentsData);
        console.log("departmentsData length:", departmentsData?.length);

        if (departmentsData && departmentsData.length > 0) {
          console.log("Первый отдел:", departmentsData[0]);
          console.log("Ключи первого отдела:", Object.keys(departmentsData[0]));
        }

        // Фильтруем отделы в зависимости от прав пользователя
        let filteredDepartments = departmentsData;

        // Проверяем права доступа к отделам
        const hasFullAccess =
          userData &&
          (userData.id === 63 ||
            (userData.access_levels &&
              userData.access_levels.some(
                (level) => level.name === "ИК" || level.name === "АДМС"
              )));

        if (!hasFullAccess) {
          // Для РО и НО показываем только их отделы
          const userDepartments = [];
          if (userData && userData.departments) {
            userData.departments.forEach((dept) => {
              if (dept.groups && dept.groups.length > 0) {
                dept.groups.forEach((group) => {
                  // Проверяем, что группа активна (is_active !== false)
                  // undefined считается активной группой
                  if (group.is_active !== false) {
                    userDepartments.push({
                      id: group.id,
                      name: group.name,
                      group_id: group.id,
                    });
                  }
                });
              }
            });
          }

          console.log("Отделы пользователя:", userDepartments);

          filteredDepartments = departmentsData.filter((dept) => {
            const isMatch = userDepartments.some(
              (userDept) =>
                userDept.id === dept.id || userDept.group_id === dept.group_id
            );
            console.log(
              `Отдел "${dept.name}" (id: ${dept.id}) - совпадение:`,
              isMatch
            );
            return isMatch;
          });
          console.log("Отфильтрованные отделы:", filteredDepartments);
        }

        const departmentsList = filteredDepartments.map((dept, index) => {
          console.log(`Отдел ${index}:`, dept);
          console.log(`group_id:`, dept.group_id);
          console.log(`id:`, dept.id);
          console.log(`name:`, dept.name);
          return {
            value: dept.group_id || dept.id, // Попробуем и group_id и id
            label: dept.name,
          };
        });
        console.log("departmentsList:", departmentsList);
        setDepartments(departmentsList);

        // Сотрудники будут загружаться при выборе отдела

        // Устанавливаем первый отдел по умолчанию
        if (departmentsList.length > 0) {
          console.log("Устанавливаем отдел по умолчанию:", departmentsList[0]);
          setSelectedDepartment(departmentsList[0]);
        } else {
          console.log("Нет отделов для установки по умолчанию");
        }
      } catch (error) {
        console.error("Ошибка при загрузке данных:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [userData]);

  // Функция для загрузки сотрудников отдела
  const loadDepartmentEmployees = async (groupId) => {
    if (!groupId) {
      setDepartmentEmployees([]);
      return;
    }

    try {
      console.log("Загружаем сотрудников отдела:", groupId);
      const employeesData = await getUsersSummary({
        groupId: groupId,
        pageSize: 1000,
      });

      console.log("Сотрудники отдела:", employeesData);

      const employeesList = (employeesData.users || []).map((user, index) => {
        console.log(`Пользователь ${index}:`, user);
        console.log(`user.user_id:`, user.user_id);
        console.log(`user.id:`, user.id);
        console.log(`Ключи пользователя:`, Object.keys(user));

        return {
          value: user.user_id || user.id, // Попробуем и user_id и id
          label: `${user.surname} ${user.name}`,
          user: user,
        };
      });

      console.log("Список сотрудников отдела:", employeesList);
      setDepartmentEmployees(employeesList);
    } catch (error) {
      console.error("Ошибка при загрузке сотрудников отдела:", error);
      setDepartmentEmployees([]);
    }
  };

  // Функция для загрузки детальных данных сотрудника
  const loadEmployeeDetails = async (employeeId, period, date) => {
    console.log("loadEmployeeDetails вызвана с параметрами:", {
      employeeId,
      period,
      date,
    });

    if (!employeeId) {
      console.log("employeeId не предоставлен, очищаем данные");
      setEmployeeDetails(null);
      return;
    }

    try {
      console.log("Начинаем загрузку детальных данных сотрудника...");
      setEmployeeDetailsLoading(true);
      setEmployeeDetailsError(null);

      let data;
      const year = date.getFullYear();
      const month = date.getMonth() + 1;

      console.log("Параметры запроса:", { year, month, period });

      if (period === "month") {
        data = await getEmployeeAttendanceMonth(employeeId, year, month);
      } else if (period === "6months") {
        const startDate = new Date(date);
        const endDate = new Date(date);
        endDate.setMonth(endDate.getMonth() + 5);

        data = await getEmployeeAttendance6Month(
          employeeId,
          startDate.getFullYear(),
          startDate.getMonth() + 1,
          endDate.getFullYear(),
          endDate.getMonth() + 1
        );
      } else if (period === "year") {
        data = await getEmployeeAttendanceYear(employeeId, year);
      }

      setEmployeeDetails(data);
    } catch (error) {
      console.error("Ошибка при загрузке детальных данных сотрудника:", error);
      setEmployeeDetailsError(error.message);
    } finally {
      setEmployeeDetailsLoading(false);
    }
  };

  // Загрузка данных дисциплины при изменении параметров
  useEffect(() => {
    console.log("useEffect для дисциплины сработал:", {
      selectedDepartment,
      selectedPeriod,
      selectedMonth,
    });

    if (
      selectedDepartment &&
      selectedDepartment.value &&
      selectedDepartment.value !== "all"
    ) {
      console.log("Вызываем loadDisciplineData и loadDepartmentEmployees");
      loadDisciplineData(
        selectedDepartment.value,
        selectedPeriod,
        selectedMonth
      );
      loadDepartmentEmployees(selectedDepartment.value);

      // Сбрасываем выбранного сотрудника при смене отдела, периода или месяца
      console.log("Сбрасываем выбранного сотрудника при смене параметров");
      setSelectedEmployee(null);
      setEmployeeDetails(null);
    } else {
      console.log("Отдел не выбран или выбран 'all' или value undefined");
      console.log("selectedDepartment:", selectedDepartment);
      setDepartmentEmployees([]);
      setSelectedEmployee(null);
      setEmployeeDetails(null);
    }
  }, [selectedDepartment, selectedPeriod, selectedMonth]);

  // Загрузка детальных данных сотрудника при изменении выбранного сотрудника
  useEffect(() => {
    console.log("useEffect для сотрудника сработал:", {
      selectedEmployee,
      selectedPeriod,
      selectedMonth,
    });

    if (selectedEmployee && selectedEmployee.value) {
      console.log("Вызываем loadEmployeeDetails с параметрами:", {
        employeeId: selectedEmployee.value,
        period: selectedPeriod,
        month: selectedMonth,
      });
      loadEmployeeDetails(
        selectedEmployee.value,
        selectedPeriod,
        selectedMonth
      );
    } else {
      console.log("Сотрудник не выбран или value undefined");
      setEmployeeDetails(null);
    }
  }, [selectedEmployee, selectedPeriod, selectedMonth]);

  const handleMonthChange = (direction) => {
    const newMonth = new Date(selectedMonth);
    if (direction === "prev") {
      if (selectedPeriod === "year") {
        newMonth.setFullYear(newMonth.getFullYear() - 1);
      } else if (selectedPeriod === "6months") {
        newMonth.setMonth(newMonth.getMonth() - 6);
      } else {
        newMonth.setMonth(newMonth.getMonth() - 1);
      }
    } else {
      if (selectedPeriod === "year") {
        newMonth.setFullYear(newMonth.getFullYear() + 1);
      } else if (selectedPeriod === "6months") {
        newMonth.setMonth(newMonth.getMonth() + 6);
      } else {
        newMonth.setMonth(newMonth.getMonth() + 1);
      }
    }
    setSelectedMonth(newMonth);
  };

  const formatMonthYear = (date) => {
    const months = [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ];

    if (selectedPeriod === "year") {
      return `${date.getFullYear()}`;
    } else if (selectedPeriod === "6months") {
      const startMonth = new Date(date);
      const endMonth = new Date(date);
      endMonth.setMonth(endMonth.getMonth() + 5);
      return `${months[startMonth.getMonth()]} ${startMonth.getFullYear()} - ${
        months[endMonth.getMonth()]
      } ${endMonth.getFullYear()}`;
    } else {
      return `${months[date.getMonth()]} ${date.getFullYear()}`;
    }
  };

  // Фильтрация сотрудников по отделу
  const getFilteredEmployees = () => {
    if (!disciplineData || !disciplineData.employees) {
      return [];
    }
    return disciplineData.employees.map((employee, index) => ({
      id: index + 1,
      name: employee.full_name,
      tardinessCount: employee.late_count,
      averageTardinessTime: employee.avg_late_time,
      withoutTardinessPercent: 100 - employee.lateness_percent,
      timesheetDiscrepancyDays: employee.report_mismatch_count,
    }));
  };

  // Получение сотрудников для селекта
  const getEmployeesForSelect = () => {
    console.log("getEmployeesForSelect вызвана");
    console.log("selectedDepartment:", selectedDepartment);
    console.log("departmentEmployees:", departmentEmployees);
    console.log("departmentEmployees.length:", departmentEmployees.length);

    // Возвращаем сотрудников конкретного отдела
    return departmentEmployees;
  };

  // Функция для сравнения времени в формате "HH:MM"
  const compareTime = (time1, time2) => {
    if (!time1 || !time2) return null;
    const [h1, m1] = time1.split(":").map(Number);
    const [h2, m2] = time2.split(":").map(Number);
    const minutes1 = h1 * 60 + m1;
    const minutes2 = h2 * 60 + m2;
    if (minutes1 < minutes2) return -1; // time1 раньше time2
    if (minutes1 > minutes2) return 1; // time1 позже time2
    return 0; // равны
  };

  // Получить детали сотрудника
  const getEmployeeDetails = () => {
    if (!employeeDetails) {
      return [];
    }

    if (selectedPeriod === "month" && employeeDetails.days) {
      return employeeDetails.days.map((day, index) => {
        const isWeekend = !day.workday_flag;

        // Если выходной день, показываем данные если они есть, иначе "Выходной день"
        if (isWeekend) {
          return {
            id: index + 1,
            date: new Date(day.work_date).toLocaleDateString("ru-RU"),
            scheduledStart: day.work_start_time || "Выходной день",
            actualArrival: day.first_entry || "Выходной день",
            delayGroup: "-",
            arrivalCategory: "Вовремя",
            departureTime: day.last_exit || "Выходной день",
            actualTimeInOffice: day.office_time || "Выходной день",
            scheduledTimeInOffice: day.report_time_spent || "0:00",
            deviation: day.time_diff || "0:00",
            comment: day.comment || "Все в порядке",
            isWeekend: true,
          };
        }

        // Проверяем, пришел ли сотрудник вовремя или раньше
        const isOnTimeOrEarly =
          day.first_entry &&
          day.work_start_time &&
          compareTime(day.first_entry, day.work_start_time) <= 0;

        // Если пришел вовремя или раньше, или нет данных о времени прихода
        if (isOnTimeOrEarly || !day.late_hours_minutes) {
          return {
            id: index + 1,
            date: new Date(day.work_date).toLocaleDateString("ru-RU"),
            scheduledStart: day.work_start_time,
            actualArrival: day.first_entry,
            delayGroup: "-",
            arrivalCategory: day.late_type || "Вовремя",
            departureTime: day.last_exit,
            actualTimeInOffice: day.office_time,
            scheduledTimeInOffice: day.report_time_spent,
            deviation: day.time_diff,
            comment: day.comment || "Все в порядке",
            isWeekend: false,
          };
        }

        // Если есть опоздание, определяем категорию по времени опоздания
        const lateMinutes =
          parseInt(day.late_hours_minutes.split(":")[0]) * 60 +
          parseInt(day.late_hours_minutes.split(":")[1]);

        return {
          id: index + 1,
          date: new Date(day.work_date).toLocaleDateString("ru-RU"),
          scheduledStart: day.work_start_time,
          actualArrival: day.first_entry,
          delayGroup: lateMinutes <= 10 ? "0-10" : "10-30",
          arrivalCategory:
            day.late_type ||
            (lateMinutes <= 10 ? "Незначительное опоздание" : "Опаздание"),
          departureTime: day.last_exit,
          actualTimeInOffice: day.office_time,
          scheduledTimeInOffice: day.report_time_spent,
          deviation: day.time_diff,
          comment: day.comment || "Все в порядке",
          isWeekend: false,
        };
      });
    } else if (
      (selectedPeriod === "6months" || selectedPeriod === "year") &&
      employeeDetails.months
    ) {
      return employeeDetails.months.map((month, index) => ({
        id: index + 1,
        date: month.month,
        scheduledStart: month.workdays_count,
        actualArrival: month.lateness_count,
        delayGroup: "0-10",
        arrivalCategory: `${month.average_lateness} мин`,
        departureTime: `${month.intime_percentage}%`,
        actualTimeInOffice: month.report_mismatches_count,
        scheduledTimeInOffice: month.workdays_count,
        deviation: month.lateness_count,
        comment: "Все в порядке",
        isWeekend: false,
      }));
    }

    return [];
  };

  // Получить статистику по отделу
  const getDepartmentStats = () => {
    if (!disciplineData || !disciplineData.summary) {
      return {
        totalEmployees: 0,
        averageWithoutTardiness: 0,
        totalTardiness: 0,
        averageTardinessTime: 0,
      };
    }

    const summary = disciplineData.summary;
    return {
      totalEmployees: summary.total_employees,
      averageWithoutTardiness: Math.round(100 - summary.avg_lateness_percent),
      totalTardiness: summary.total_late_count,
      averageTardinessTime: summary.avg_late_time,
    };
  };

  const stats = getDepartmentStats();

  // Отладочная информация
  console.log("Текущие состояния:", {
    loading,
    selectedDepartment,
    selectedPeriod,
    selectedMonth,
    disciplineData,
    disciplineLoading,
    disciplineError,
    stats,
  });

  console.log("API URL:", getAPIURL());
  console.log("process.env.REACT_APP_API_URL:", process.env.REACT_APP_API_URL);
  console.log("NODE_ENV:", process.env.NODE_ENV);

  if (loading) {
    return (
      <div className="employee-discipline-container">
        <div className="employee-discipline-section">
          <div style={{ textAlign: "center", padding: "50px" }}>
            <h3>Загрузка данных...</h3>
          </div>
        </div>
      </div>
    );
  }

  if (disciplineError) {
    return (
      <div className="employee-discipline-container">
        <div className="employee-discipline-section">
          <div style={{ textAlign: "center", padding: "50px" }}>
            <h3>Ошибка загрузки данных дисциплины</h3>
            <p>{disciplineError}</p>
            <button
              onClick={() => {
                if (selectedDepartment && selectedDepartment.value !== "all") {
                  loadDisciplineData(
                    selectedDepartment.value,
                    selectedPeriod,
                    selectedMonth
                  );
                }
              }}
              style={{ marginTop: "20px", padding: "10px 20px" }}
            >
              Попробовать снова
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="employee-discipline-container">
      <div className="employee-discipline-section">
        {/* Заголовок и навигация */}
        <div className="section-header">
          <h2 className="section-title">Дисциплина по отделу</h2>
          <div className="employee-month-navigation">
            <button
              className="employee-nav-button"
              onClick={() => handleMonthChange("prev")}
            >
              ←
            </button>
            <span className="employee-current-month">
              {formatMonthYear(selectedMonth)}
            </span>
            <button
              className="employee-nav-button"
              onClick={() => handleMonthChange("next")}
            >
              →
            </button>
          </div>
          <div className="employee-period-buttons">
            <button
              className={`employee-period-button ${
                selectedPeriod === "year" ? "active" : ""
              }`}
              onClick={() => setSelectedPeriod("year")}
            >
              Год
            </button>
            <button
              className={`employee-period-button ${
                selectedPeriod === "6months" ? "active" : ""
              }`}
              onClick={() => setSelectedPeriod("6months")}
            >
              6 месяцев
            </button>
            <button
              className={`employee-period-button ${
                selectedPeriod === "month" ? "active" : ""
              }`}
              onClick={() => setSelectedPeriod("month")}
            >
              Месяц
            </button>
          </div>
        </div>

        {/* Селект выбора отдела */}
        <div className="department-selector">
          <label>Выбор отдела:</label>
          <Select
            value={selectedDepartment}
            onChange={setSelectedDepartment}
            options={departments}
            placeholder="Выберите отдел"
            isDisabled={loading}
            isLoading={loading}
            styles={customSelectStyles}
            className="department-select"
            menuPlacement="auto"
            menuPosition="fixed"
            noOptionsMessage={() => "Нет доступных отделов"}
          />
        </div>

        {/* Карточки с данными по отделу */}
        {disciplineLoading ? (
          <div style={{ textAlign: "center", padding: "50px" }}>
            <h3>Загрузка данных дисциплины...</h3>
          </div>
        ) : (
          <div className="stats-cards">
            <div className="stat-card">
              <div className="stat-icon employees-icon">👥</div>
              <div className="stat-content">
                <div className="stat-label">Количество сотрудников</div>
                <div className="stat-value">{stats.totalEmployees}</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon success-icon">✓</div>
              <div className="stat-content">
                <div className="stat-label">Средний % без опозданий</div>
                <div className="stat-value">
                  {stats.averageWithoutTardiness}%
                </div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon warning-icon">⚠</div>
              <div className="stat-content">
                <div className="stat-label">Всего опозданий</div>
                <div className="stat-value">{stats.totalTardiness}</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon time-icon">🕐</div>
              <div className="stat-content">
                <div className="stat-label">Среднее время опозданий</div>
                <div className="stat-value">{stats.averageTardinessTime}</div>
              </div>
            </div>
          </div>
        )}

        {/* Диаграмма с количеством опозданий */}
        {!disciplineLoading && (
          <div className="chart-section">
            <div className="chart-title">Количество опозданий</div>
            <div className="employee-chart">
              <div className="chart-grid">
                <div className="grid-line"></div>
                <div className="grid-line"></div>
                <div className="grid-line"></div>
                <div className="grid-line"></div>
                <div className="grid-line"></div>
                <div className="grid-label">0</div>
                <div className="grid-label">4</div>
                <div className="grid-label">8</div>
                <div className="grid-label">12</div>
                <div className="grid-label">16</div>
                <div className="grid-label">20</div>
              </div>
              <div className="employees-list">
                {getFilteredEmployees().map((employee) => (
                  <div key={employee.id} className="employee-row">
                    <div className="employee-information">{employee.name}</div>
                    <div className="employee-bar-container">
                      <div
                        className="employee-bar"
                        style={{
                          width: `${(employee.tardinessCount / 20) * 100}%`,
                          backgroundColor:
                            employee.tardinessCount > 10
                              ? "rgba(185, 28, 28, 0.6)"
                              : employee.tardinessCount >= 5
                              ? "rgba(220, 38, 38, 0.6)"
                              : "rgba(252, 165, 165, 0.6)",
                        }}
                      ></div>
                      <div className="bar-value">{employee.tardinessCount}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Таблица с детальными данными */}
        {!disciplineLoading && (
          <div className="employees-table">
            <table>
              <thead>
                <tr>
                  <th>ФИО</th>
                  <th>Количество опозданий</th>
                  <th>Среднее время опозданий</th>
                  <th>% без опозданий</th>
                  <th>Количество дней с несоответствием табелю</th>
                </tr>
              </thead>
              <tbody>
                {getFilteredEmployees().map((employee) => (
                  <tr key={employee.id}>
                    <td>{employee.name}</td>
                    <td>{employee.tardinessCount}</td>
                    <td>{employee.averageTardinessTime}</td>
                    <td>{employee.withoutTardinessPercent}%</td>
                    <td>{employee.timesheetDiscrepancyDays}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Селект выбора сотрудника */}
        <div className="employee-selector">
          <h3 className="employee-selector-title">Детали по сотруднику</h3>
          <div className="employee-selector-field">
            <label>Выбор сотрудника*</label>
            <Select
              value={selectedEmployee}
              onChange={setSelectedEmployee}
              options={getEmployeesForSelect()}
              placeholder={
                departmentEmployees.length > 0
                  ? "Выберите сотрудника"
                  : "Сначала выберите отдел"
              }
              isDisabled={loading}
              isLoading={loading}
              styles={customSelectStyles}
              className="employee-select"
              menuPlacement="auto"
              menuPosition="fixed"
              noOptionsMessage={() =>
                departmentEmployees.length === 0
                  ? "Сначала выберите отдел"
                  : "Нет доступных сотрудников"
              }
            />
          </div>
        </div>

        {/* Таблица деталей сотрудника */}
        {selectedEmployee && (
          <div className="employee-details-section">
            {employeeDetailsLoading ? (
              <div style={{ textAlign: "center", padding: "50px" }}>
                <h3>Загрузка детальных данных сотрудника...</h3>
              </div>
            ) : employeeDetailsError ? (
              <div style={{ textAlign: "center", padding: "50px" }}>
                <h3>Ошибка загрузки детальных данных</h3>
                <p>{employeeDetailsError}</p>
                <button
                  onClick={() => {
                    if (selectedEmployee && selectedEmployee.value) {
                      loadEmployeeDetails(
                        selectedEmployee.value,
                        selectedPeriod,
                        selectedMonth
                      );
                    }
                  }}
                  style={{ marginTop: "20px", padding: "10px 20px" }}
                >
                  Попробовать снова
                </button>
              </div>
            ) : (
              <div className="table-container">
                <table className="discipline-table">
                  <thead>
                    <tr>
                      {selectedPeriod === "month" ? (
                        <>
                          <th>Дата</th>
                          <th>Начало дня по графику</th>
                          <th>Фактическое время прихода</th>
                          <th>Группа опозданий</th>
                          <th>Категория прихода</th>
                          <th>Время ухода</th>
                          <th>Фактическое время в офисе</th>
                          <th>Время в офисе по табелю</th>
                          <th>Отклонение по табелю</th>
                          <th>Комментарий</th>
                        </>
                      ) : selectedPeriod === "6months" ? (
                        <>
                          <th>Месяц</th>
                          <th>Рабочих дней</th>
                          <th>Всего опозданий</th>
                          <th>Среднее время опоздания</th>
                          <th>% без опозданий</th>
                          <th>Количество дней с несоответствием табелю</th>
                        </>
                      ) : (
                        <>
                          <th>Год</th>
                          <th>Рабочих дней</th>
                          <th>Всего опозданий</th>
                          <th>Среднее время опоздания</th>
                          <th>% без опозданий</th>
                          <th>Количество дней с несоответствием табелю</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {getEmployeeDetails().map((detail, index) => (
                      <tr
                        key={detail.id}
                        className={detail.isWeekend ? "weekend-row" : ""}
                      >
                        <td>{detail.date}</td>
                        <td>{detail.scheduledStart}</td>
                        <td>{detail.actualArrival}</td>
                        {selectedPeriod === "month" ? (
                          <>
                            <td>
                              {detail.delayGroup !== "-" && (
                                <div
                                  className={`delay-group delay-group--${
                                    detail.delayGroup === "0-10"
                                      ? "yellow"
                                      : "orange"
                                  }`}
                                >
                                  {detail.delayGroup}
                                </div>
                              )}
                              {detail.delayGroup === "-" && "-"}
                            </td>
                            <td>
                              {detail.delayGroup === "-"
                                ? "Вовремя"
                                : detail.delayGroup === "0-10"
                                ? "Незначительное опоздание"
                                : detail.delayGroup === "10-30"
                                ? "Опаздание"
                                : detail.arrivalCategory || "-"}
                            </td>
                            <td>{detail.departureTime}</td>
                            <td>{detail.actualTimeInOffice}</td>
                            <td>{detail.scheduledTimeInOffice}</td>
                            <td
                              className={
                                detail.deviation?.startsWith("-")
                                  ? "negative-difference"
                                  : ""
                              }
                            >
                              {detail.deviation}
                            </td>
                            <td>
                              <div className="comment-cell">
                                {detail.comment === "Все в порядке" && (
                                  <span className="status-icon status-icon--good">
                                    ✓
                                  </span>
                                )}
                                {detail.comment !== "Все в порядке" && (
                                  <span className="status-icon status-icon--warning">
                                    ⚠
                                  </span>
                                )}
                                {detail.comment}
                              </div>
                            </td>
                          </>
                        ) : (
                          <>
                            <td>{detail.actualArrival}</td>
                            <td>{detail.arrivalCategory}</td>
                            <td>{detail.departureTime}</td>
                            <td>{detail.actualTimeInOffice}</td>
                            <td>{detail.scheduledTimeInOffice}</td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeDiscipline;
